import React from "react";
import "../styles/homeBanner.scss";
import bannerHome from "../images/homeBanner.webp";

export default function UniformsHome() {
  return (
    <div>
      <div className="uniforms">
        <div className="main-container uniforms-text">
          <h1>
            <span style={{ color: "#56c7d8" }}>Prilagodjene</span> uniforme za
            vaš tim
          </h1>
          <p id="uniforms-subtitle">
            Profesionalne uniforme dizajnirane da zadovolje sve vaše potrebe
          </p>
          <div className="banner-btn">
            <a
              href="/galerija"
              style={{
                background: "transparent",
                border: "1px solid #000",
                color: "#000"
              }}
            >
              Pogledaj naše radove
            </a>
            <a href="/kontakt" style={{ color: "#fff" }}>
              Poruči uniformu
            </a>
          </div>
          <img src={bannerHome} alt="Banner Home" />
        </div>
      </div>
    </div>
  );
}
